export default [
  {
    path: '/admin/trader/targets',
    name: 'Targets',
    component: () => import('@/views/Admin/Trader/Targets/Index.vue'),
    meta: {
      pageTitle: 'Hedefler',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Hedefler', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
